export default {
  coreOptions: {
    resize: true,
    useWorker: true,
    disableForReducedMotion: true,
  },

  renderOptions: {
    particleCount: 200,
    origin: {
      x: 0.5,
      y: 0.5,
    },
  },
};
